export enum VorgangsTyp {
  // gui depends on given order of elements in this enum.
  AUFGABE = 'AUFGABE',
  TERMIN = 'TERMIN',
  INFORMATION = 'INFORMATION',
  GESAMTLAST = 'GESAMTLAST',
  ABWURFPUNKTE_AUFGABE = 'ABWURFPUNKTE_AUFGABE',
  ABWURFPUNKTE_INFORMATION = 'ABWURFPUNKTE_INFORMATION'
}
